<kt-base-modal [title]="'Fill Form'">
  <div modal-body>
    <div>
      <div class="fix-body-height">
        <ngb-accordion #acc="ngbAccordion" id="ngb-panel-0">
          <ng-container *ngFor="let form of forms;let index = index">
            <ngb-panel id="ngb-panel-{{index}}">
              <ng-template ngbPanelHeader let-opened="opened">
                <div class="d-flex align-items-center justify-content-between m-1 p-2">
                  <h6 class="m-0">
                    <span class="w-100">
                      <span>{{form.form_name}}<span class="text-danger" *ngIf="form?.location_form_is_required"> *</span></span>({{form.form_description}})</span>
                  </h6>
                  <div>
                    <a class="btn btn-sm btn-clean btn-icon btn-icon-sm ms-3" [class.action-in-flight]="loading()"
                      (click)="formEditClickHandler($event, form)" href="javascript:;">
                      <svg-icon *ngIf="!viewMode" class="svg_icon13x13 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/add.svg"></svg-icon>
                      <svg-icon *ngIf="viewMode" class="svg_icon13x13 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/view.svg"></svg-icon>
                    </a>
                    <button ngbPanelToggle [hidden]="viewMode && !form?.actual_form?.length"
                      class="btn btn-sm btn-icon btn-icon-sm" href="javascript:;">
                      <svg-icon class=" d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/angle_down.svg"></svg-icon>
                    </button>
                  </div>

                </div>
              </ng-template>
              <ng-template ngbPanelTitle>
              </ng-template>
              <ng-template ngbPanelContent>
                <ng-container *ngFor="let item of form.actual_form">
                  <div class="form-list-item border-bottom">

                    <div class="description me-3 w-100">
                      <span><b>Form Name: </b>{{item.timesheet_log_name}}</span>
                      <span><b>Filled At: </b>{{item.timesheet_log_created_at | TimezoneDateTime}}</span>
                    </div>

                    <div>
                      <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" [disabled]="loading()"
                        (click)="formEditClickHandler($event, form, item )">
                        <svg-icon class="d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/view.svg"></svg-icon>
                      </button>
                    </div>

                  </div>
                </ng-container>
              </ng-template>
            </ngb-panel>
          </ng-container>
        </ngb-accordion>
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
        </kt-button>
      </div>

    </div>
  </div>
</kt-base-modal>